import { render } from "./ListScroll.vue?vue&type=template&id=bcfe25dc&scoped=true"
import script from "./ListScroll.vue?vue&type=script&lang=js"
export * from "./ListScroll.vue?vue&type=script&lang=js"

import "./ListScroll.vue?vue&type=style&index=0&id=bcfe25dc&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfe25dc"]])

export default __exports__